<template>
  <div id="app">
    <router-view v-if="!userAgent"></router-view>

    <div v-if="userAgent" class="load-content">
      <div class="prompt-wrapper">
        <div class="prompt-wrapper--img mt150">
          <img src="@/assets/images/load.png" alt="" />
        </div>
        <p class="prompt-wrapper--text ft20 mt50">
          您的浏览器版本过低，可能无法体验最佳效果
        </p>
        <p id="browser_info" class="prompt-wrapper--text ft20">
          如果您已安装了谷歌浏览器80版本，请使用并体验最佳效果。或者下载安装以下浏览器
        </p>
      </div>
      <ul class="download-infos">
        <li
          id="win_col"
          class="tac download-infos--item download-infos--item-line before-check-hidden"
        >
          <h3 class="download-infos--head mt20">
            您的操作系统是Windows7或Windows10，请下载谷歌浏览器
          </h3>
          <div class="download-infos--download">
            <el-button
              id="win_col_32"
              class="mt40"
              type="primary"
              plain
              @click="loadFnc"
              >立即下载
            </el-button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "App",
  data() {
    return {
      userAgent: false
    };
  },
  created() {
    this.userAgent = navigator.userAgent.indexOf("Chrome") === -1;
    // this.loadFnc()
  },
  methods: {
    loadFnc() {
      window.open("https://www.google.cn/chrome/");
    }
  }
};
</script>

<style lang="stylus">
#app
  font-family Avenir, Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  text-align center
  color #2c3e50
  height 100%
</style>
